// Work-order list filters (Appointments, S&R, RQ, UQ): which list a route is, and the filter values kept in the URL
// query as `f.<param>=v` / multi-select `f.<param>[]=v1,v2` (so they survive detail → back like page / sort,
// see listQueryState.js). The `[]` marks an array param for the API.
export const LIST_BY_ROUTE = {
  appointment: "appointment",
  serviceRepair: "sar",
  replacementQuote: "rq",
  universalQuotes: "uq",
};

import moment from "moment";

const PREFIX = "f.";

// Default filters on every work-order list (user, 21 Oct): Date Range = Year to Date (01/01 … today). Applied and sent
// to the API even when the drawer was never opened; not written to the URL and not counted in the badge.
export function defaultFilters() {
  return { date_range: [`${moment().startOf("year").format("MM/DD/YYYY")} - ${moment().format("MM/DD/YYYY")}`] };
}

function isDefault(key, values) {
  const def = defaultFilters()[key];
  return !!def && values.length === def.length && values.every((v, i) => String(v) === String(def[i]));
}

// { "statuses[]": ["1","2"], date_range: ["…"] } from the route query, with the defaults for keys not in it
export function filtersFromQuery(query = {}) {
  const out = { ...defaultFilters() };
  Object.keys(query).forEach((k) => {
    if (!k.startsWith(PREFIX)) return;
    const values = String(query[k] ?? "").split(",").map((v) => v.trim()).filter(Boolean);
    if (values.length) out[k.slice(PREFIX.length)] = values;
  });
  return out;
}

// route query with the filters replaced (empty ones dropped); paging restarts at 1
export function queryWithFilters(query = {}, filters = {}) {
  const next = {};
  Object.keys(query).forEach((k) => {
    if (!k.startsWith(PREFIX) && k !== "page") next[k] = query[k];
  });
  Object.keys(filters).forEach((key) => {
    const values = (filters[key] || []).map(String).filter((v) => v !== "");
    if (values.length && !isDefault(key, values)) next[PREFIX + key] = values.join(",");
  });
  return next;
}

// API params: `key[]` → array (axios sends key[]=…), plain key → single value
export function filterParams(filters = {}) {
  const params = {};
  Object.keys(filters).forEach((key) => {
    if (key.endsWith("[]")) params[key.slice(0, -2)] = filters[key];
    else params[key] = filters[key][0];
  });
  return params;
}

// query key of a filter definition
export function filterQueryKey(filter) {
  return filter.isMultiple ? filter.key + "[]" : filter.key;
}

// number of filters the user set (badge); the default Year to Date doesn't count
export function filterCount(filters = {}) {
  return Object.keys(filters).filter((k) => filters[k] && filters[k].length && !isDefault(k, filters[k])).length;
}
